export function escapeMarkup(unsafe) {
  if (typeof unsafe === 'number') {
    unsafe = unsafe.toString()
  }

  if (typeof unsafe !== 'string') {
    return ''
  }

  return unsafe.replace(/[\u00A0-\u017e\u0180-\u9999<>&]/gim, function (i) {
    return `&#${i.charCodeAt(0)};`
  })
}
